import React from 'react';
import { BookOpen } from 'lucide-react';
export function FooterSection() {
  return <footer className="bg-[#0D0D1A] pt-2 pb-[110px] md:pt-3 md:pb-5 px-4 text-center border-t border-white/5" data-id="element-181" data-mp="3399krv2gfiu6">
      <div className="max-w-4xl mx-auto space-y-1.5" data-id="element-182" data-mp="3h9ak3632mi7j">
        {/* Small logo */}
        <div className="flex items-center justify-center gap-1.5 mb-1.5" data-id="element-183" data-mp="3c9xonwy4w2tc">
          <span className="font-display font-black text-base tracking-tight text-white" data-id="element-184" data-mp="3c7l7vn443yhv">
            PRODI
          </span>
          <span className="font-display font-black text-base tracking-tight text-gold" data-id="element-185" data-mp="2kirvy1kqt7e3">
            KIT
          </span>
          <div className="w-5 h-5 rounded-md bg-gradient-to-br from-gold to-orange flex items-center justify-center" data-id="element-186" data-mp="2ya6ek7aqn6km">
            <BookOpen className="w-3 h-3 text-white" strokeWidth={2.5} data-id="element-187" data-mp="2tieoryzep4vj" />
          </div>
        </div>

        <p className="text-[#888888] text-[10px] md:text-xs leading-snug" data-id="element-188" data-mp="25sauii83yhh7">
          © MegaPack Vianda Resuelta — Prodikit — Todos los derechos reservados
        </p>

        <div className="flex flex-wrap justify-center items-center gap-x-2 gap-y-0.5 text-[#888888] text-[10px] md:text-xs" data-id="element-189" data-mp="1gh83rgxundic">
          <a href="https://www.prodikit.com" className="hover:text-gold transition-colors" data-id="element-190" data-mp="1lei0lhnkirg7">
            www.prodikit.com
          </a>
          <span className="text-white/20" data-id="element-191" data-mp="1v646qzl1u0c3">|</span>
          <a href="mailto:soporteprodikit@gmail.com" className="hover:text-gold transition-colors" data-id="element-192" data-mp="1v4t3r1zfgwm1">
            soporteprodikit@gmail.com
          </a>
          <span className="text-white/20" data-id="element-193" data-mp="12hgsvp2mqd8k">|</span>
          <a href="#" className="hover:text-gold transition-colors" data-id="element-194" data-mp="17g9v2lcguhtf">
            @prodikitshop
          </a>
        </div>

        <p className="text-[#666666] text-[9px] md:text-[11px] italic max-w-md mx-auto leading-snug" data-id="element-195" data-mp="1bhve6oflfsc2">
          Precios en USD. Cobro en la moneda local de tu país.
        </p>
      </div>
    </footer>;
}